import { CardsTotalsByAccountContext } from 'core/tarjeta/contexts/CardsTotalsByAccountContext';
import { useContext } from 'react';
import { formatCurrency, formatDateParams } from 'shared/utils';
import { Button, Card, Col, Row } from 'react-bootstrap';

export const CardsTotalsByAccountDisplayInformation = () => {
  const { cardsTotalsData, goToSearch, goToBusinessMovements, searchParams } = useContext(
    CardsTotalsByAccountContext,
  );

  return (
    <>
      {cardsTotalsData && (
        <Card>
          <Card.Header className="text-center" data-testid="title">
            {cardsTotalsData.cuenta.empresa.denominacion.toUpperCase()}
          </Card.Header>
          <Card.Body>
            <Row>
              <Col>
                <p className="fw-semibold">
                  Denominacion: {cardsTotalsData.cuenta.denominacion}
                </p>
              </Col>
              <Col>
                <p className="fw-semibold">
                  Nro. de cuenta: {cardsTotalsData.cuenta.numeroCuenta}
                </p>
              </Col>
            </Row>
            <p className="fw-semibold">
              Saldo Inicial: {formatCurrency(cardsTotalsData.cuenta.saldoDisponible)}
            </p>
            <p className="fw-semibold text-center">
              Total Centro de Costos - Apertura por Tarjeta
            </p>
            <p className="fw-semibold text-center">{formatDateParams(searchParams)}</p>
            <Row>
              <Col className="text-center">
                <Button
                  variant="secondary"
                  onClick={goToBusinessMovements}
                  className="me-2"
                >
                  Ver movimientos del centro de costo
                </Button>
                <Button variant="secondary" onClick={() => goToSearch()}>
                  Volver
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
    </>
  );
};
